import { setAppAuthData, setAuthData, setLogoAuthData } from 'app/slice/authSlice';
import logoContractImg from 'assets/images/logo/xCyber-contract.png';
import logoImg from 'assets/images/logo/xCyber-doc.png';
import { APP_ECONTRACT, APP_SIGN, SYSTEM_APP_ECONTRACT } from 'constants/global';
import { routerMain } from 'constants/routerMain';
import getSystem from 'helpers/getSystem';
import React, { lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import DefaultContainer from './DefaultContainer';

const MainPage = (props) => {
    const HomePage = lazy(() => import('features/home-page/HomePage'));
    const CheckPage = lazy(() => import('features/home-page/CheckPage'));
    const EmptyPage = lazy(() => import('components/EmptyPage/EmptyPage'));
    const SignClient = lazy(() => import('features/home-page/sign-client/search/SignClient'));
    const SignScreen = lazy(() => import('features/home-page/sign-client/sign/contract/SignScreen'));
    const SignScreenDocumentContract = lazy(() =>
        import('features/home-page/sign-client/sign/contract-document/SignScreenDocumentContract')
    );
    const QuickSignScreen = lazy(() => import('features/home-page/sign-client/sign/submission/QuickSignScreen'));
    const DocumentSignScreen = lazy(() => import('features/home-page/sign-client/sign/document/DocumentSignScreen'));
    const Page401 = lazy(() => import('components/errors/Page401'));
    const AddInformation = lazy(() => import('features/home-page/AddInformation'));
    const HPNY = lazy(() => import('features/hpny/HPNY'));


    const changeTitlePage = (item) => {
        if (item === APP_ECONTRACT) {
            document.title = 'xCyber Contract | Phần mềm hợp đồng điện tử';
        } else {
            document.title = 'xCyber Doc | Phần mềm văn bản điện tử';
        }
    };

    const getAppAuth = () => {
        const objLogoContract = {
            src: logoContractImg,
            height: 38,
        };
        const objLogoSign = {
            src: logoImg,
            height: 38,
        };
        const system = getSystem();
        if (system === SYSTEM_APP_ECONTRACT) {
            props.setAppAuthData(APP_ECONTRACT);
            props.setLogoAuthData(objLogoContract);
            changeTitlePage(APP_ECONTRACT);
        } else {
            props.setAppAuthData(APP_SIGN);
            props.setLogoAuthData(objLogoSign);
            changeTitlePage(APP_SIGN);
        }
    };

    useEffect(() => {
        getAppAuth();
        // eslint-disable-next-line
    }, [window.location.host]);

    return (
        <div className="layout-wrapper">
            <React.Fragment>
                <Switch>
                    <Route exact path={routerMain.SIGN_NUMBER} component={HomePage} />
                    <Route exact path={routerMain.CHECK_SIGN} component={CheckPage} />
                    <Route exact path={routerMain.EMPTY} component={EmptyPage} />
                    <Route exact path={`${routerMain.CLIENT_SIGN}/:path`} component={SignClient} />
                    <Route
                        exact
                        path={`${routerMain.SCREEN_SIGN}/:email/:code/:captcha/:codeClient`}
                        component={SignScreen}
                    />
                    <Route
                        exact
                        path={`${routerMain.SEARCH_SCREEN_SIGN}/:code/:captcha/:codeClient`}
                        component={SignScreen}
                    />
                    <Route
                        exact
                        path={`${routerMain.SCREEN_SIGN_CONTRACT_DOC}/:email/:code/:captcha/:codeClient`}
                        component={SignScreenDocumentContract}
                    />
                    <Route
                        exact
                        path={`${routerMain.SEARCH_SCREEN_SIGN_CONTRACT_DOC}/:code/:captcha/:codeClient`}
                        component={SignScreenDocumentContract}
                    />
                    <Route
                        exact
                        path={`${routerMain.SCREEN_SIGN_SUBMISSION}/:email/:code/:captcha/:codeClient`}
                        component={QuickSignScreen}
                    />
                    <Route
                        exact
                        path={`${routerMain.SEARCH_SCREEN_SIGN_SUBMISSION}/:code/:captcha/:codeClient`}
                        component={QuickSignScreen}
                    />
                    <Route
                        exact
                        path={`${routerMain.SEARCH_SIGN_DOCUMENT}/:code/:captcha/:codeClient`}
                        component={DocumentSignScreen}
                    />
                    <Route
                        exact
                        path={`${routerMain.HPNY}`}
                        component={HPNY}
                    />
                    <Route exact path={`${routerMain.ADD_INFORMATION}/:uuid`} component={AddInformation} />
                    <Route exact path={`${routerMain.PAGE_401}`} component={Page401} />
                    <Route component={DefaultContainer} />
                </Switch>
            </React.Fragment>
        </div>
    );
};
function mapStateToProps(state) {
    return { userData: state.auth };
}

const mapDispatchToProps = {
    setAuthData,
    setAppAuthData,
    setLogoAuthData,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
